<template>
  <transition name="fade">
    <div class="card" :class="levelClass">
      <div
        class="card-body"
        v-b-modal="'modal-' + subscription.id"
        onclick="event.preventDefault()"
      >
        <img
          :src="getCardIcon()"
          width="24"
          height="24"
          class="float-left"
          alt
        />
        <h5 class="card-title">
          Varsel om {{ subscriptionType.displayName.toLowerCase() }} &nbsp;
          &nbsp;
          <transition name="fade">
            <span v-if="!subscription.isEnabled" class="badge badge-secondary"
              >PAUSET</span
            >
          </transition>
        </h5>
        <div class="card-text">
          Nivå
          {{ getDangerLevelName(subscription.level) }}
        </div>
        <div class="card-text">{{ regionsSubscribed }}</div>
      </div>
      <div class="card-buttons">
        <div class="card-text">{{ notificationType }}</div>
        <a
          class="card-button"
          href="#"
          v-b-modal="'modal-' + subscription.id"
          onclick="event.preventDefault()"
        >
          <img src="../assets/icons/rediger.svg" alt="Fjern dette varselet" />
          Rediger
        </a>
        <a
          class="card-button"
          href="#"
          @click.prevent.stop="deleteSubscription"
        >
          <img src="../assets/icons/fjern.svg" alt="Fjern dette varselet" />
          Fjern
        </a>
        <a
          class="card-button"
          href="#"
          @click.prevent.stop="pauseSubscription"
          v-show="subscription.isEnabled"
        >
          <img src="../assets/icons/pause.svg" alt="Pause dette varselet" />
          Pause
        </a>
        <a
          class="card-button"
          href="#"
          @click.prevent.stop="resumeSubscription"
          v-show="!subscription.isEnabled"
        >
          <img src="../assets/icons/play.svg" alt="Gjenoppta dette varselet" />
          Start
        </a>
        <i class="text text-error" v-if="error">{{ error }}</i>
      </div>
      <NewOrEditSubscription
        :subscriptionType="subscriptionType"
        :existingSubscription="subscription"
        @subscriptionSaved="subscriptionSaved()"
      />
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import NewOrEditSubscription from "./NewOrEditSubscription.vue";
import TypeService from "../store/TypeService.js";

export default {
  name: "SubscriptionCard",
  props: {
    subscription: {},
    subscriptionType: {},
  },
  components: {
    NewOrEditSubscription,
  },
  data() {
    return {
      TypeService: TypeService,
      deleted: false,
      error: null,
    };
  },
  created() {},
  computed: {
    levelClass() {
      if (!this.subscription.isEnabled) {
        return "level-pause";
      }
      return `level-${this.subscription.level}`;
    },
    notificationType() {
      if (this.subscription.sendEmail && this.subscription.sendSMS) {
        return "Varsles på e-post og SMS";
      } else if (this.subscription.sendEmail) {
        return "Varsles på e-post";
      } else if (this.subscription.sendSMS) {
        return "Varsles på SMS";
      }
      return "Ingen varseltype valgt";
    },
    regionsSubscribed() {
      if (this.subscription.isRegionNorway) {
        return "Hele Norge";
      }
      let regionString = "";
      if (this.subscriptionType.regionType === 1) {
        // kommuner
        regionString = `${this.getCountyNameWithCount()}`;
        regionString = regionString.slice(0, -2); // remove last comma
      } else if (this.subscriptionType.regionType === 2) {
        // snøskredregioner
        regionString = `${this.getAvalancheRegionNames()}`;
        regionString = regionString.slice(0, -2); // remove last comma
      } else if (this.subscriptionType.regionType === 3) {
        // snøskredregioner
        regionString = `${this.getRockslideObjectNames()}`;
      }
      return regionString;
    },
  },
  methods: {
    regionNameById(id) {
      const regionId = parseInt(id, 10);
      return this.$store.getters.avalancheRegions.filter(
        (region) => region.regionId === regionId
      )[0].regionName;
    },
    getMunicipalityNameById(id) {
      const m = this.$store.getters.municipalities.filter(
        (mun) => mun.councilId === id
      )[0];
      return m.councilName;
    },
    countyNameById(id) {
      const countyId = parseInt(id, 10);
      return this.$store.getters.municipalities.filter(
        (mun) => mun.countyId === countyId
      )[0].countyName;
    },
    getNumberOfMunicipalitiesInEachCounty(list) {
      const counties = list.reduce((p, munId) => {
        const countyId = munId.toString().slice(0, -2);
        try {
          const name = this.countyNameById(countyId);
          if (!Object.prototype.hasOwnProperty.call(p, name)) {
            p[name] = 0;
          }
          p[name] += 1;
          return p;
        } catch {
          // eslint-disable-next-line
          console.warn(
            "Invalid data in subscription for county id " + countyId
          );
        }
      }, {});

      return counties;
    },
    getMunicNameByCountyName(countyName) {
      const mic = this.$store.getters.municipalities.filter(
        (mun) =>
          mun.countyName === countyName &&
          this.subscription.municipalities.includes(mun.councilId)
      );
      if (!mic || mic.length == 0) return null;
      return mic[0].councilName;
    },
    getCountyNameWithCount() {
      let returnString = "";
      const counties = this.getNumberOfMunicipalitiesInEachCounty(
        this.subscription.municipalities
      );
      const countykeys = Object.keys(counties);
      for (let i = 0; i < countykeys.length; i += 1) {
        const countyName = countykeys[i];
        const municipalityCount = counties[countykeys[i]];
        if (municipalityCount === 1) {
          const munic = this.getMunicNameByCountyName(countyName);
          if (munic === countyName) {
            // oslo
            returnString += `${munic}, `;
          } else {
            returnString += `${countyName} (${munic} kommune), `;
          }
        } else {
          returnString += `${countyName} (${municipalityCount} kommuner), `;
        }
      }
      return returnString;
    },
    getRockslideObjectNames() {
      let returnString = "";
      if (this.subscription.rockslideObjects.length == 1) {
        var rockname = this.subscription.rockslideObjects[0];
        var rockObj = this.$store.getters.rockslideObjects.filter(
          (o) => o.name == rockname
        )[0];
        returnString += `${rockObj.name} (${rockObj.kommunenavn} kommune, ${
          rockObj.fylkesnavn
        })`;
      } else {
        returnString += `${this.subscription.rockslideObjects.sort().join(", ")}`;
      }
      return returnString;
    },
    getAvalancheRegionNames() {
      let returnString = "";
      const counts = { A: 0, B: 0 };
      const avalancheRegions = this.$store.getters.avalancheRegions;
      this.subscription.avalancheRegions.forEach((regionid) => {
        const region = avalancheRegions.filter(
          (av) => av.regionId === regionid
        )[0];

        counts[region.regionType] += 1;
      });
      if (counts.A === 1) {
        returnString += `Varslingsregion (${
          avalancheRegions.filter(
            (ar) =>
              ar.regionType === "A" &&
              this.subscription.avalancheRegions.includes(ar.regionId)
          )[0].regionName
        }), `;
      } else if (counts.A > 1) {
        returnString += `Varslingsregioner (${counts.A} regioner), `;
      }
      if (counts.B === 1) {
        returnString += `Fylkesvarsel (${
          avalancheRegions.filter(
            (ar) =>
              ar.regionType === "B" &&
              this.subscription.avalancheRegions.includes(ar.regionId)
          )[0].regionName
        }), `;
      }
      if (counts.B > 1) {
        returnString += `Fylkesvarsler (${counts.B} fylker), `;
      }

      return returnString;
    },
    getDangerLevelName(hazardLevel) {
      if (this.subscriptionType.hazardTypeId === TypeService.BlowingSnow
      || this.subscriptionType.hazardTypeId === TypeService.Lightning
      ) {
        return "GULT";
      }
      let returnvalue;
      switch (this.subscriptionType.regionType) {
        case 3:
        case 1:
          switch (hazardLevel) {
            case 2:
              returnvalue = "GULT, ORANSJE, RØDT";
              break;
            case 3:
              returnvalue = "ORANSJE, RØDT";
              break;
            case 4:
              returnvalue = "RØDT";
              break;
            default:
              returnvalue = "";
              break;
          }
          break;
        case 2:
          switch (hazardLevel) {
            case 2:
              returnvalue = "GULT, ORANSJE, RØDT, SVART";
              break;
            case 3:
              returnvalue = "ORANSJE, RØDT, SVART";
              break;
            case 4:
              returnvalue = "RØDT, SVART";
              break;
            case 5:
              returnvalue = "SVART";
              break;
            default:
              returnvalue = "";
              break;
          }
          break;
        default:
          returnvalue = "";
          break;
      }

      // crazyfix fordi det SELVFØLGELIG IKKE KAN VARSLES LIKT FOR ALLE TYPER!!!!! forvent mere if'er og drit inn her
      if (
        this.subscriptionType.hazardTypeId === TypeService.PolarLow ||
        this.subscriptionType.hazardTypeId === TypeService.ForestFire ||
        this.subscriptionType.hazardTypeId === TypeService.RainFlood ||
        this.subscriptionType.hazardTypeId === TypeService.Ice
      ) {
        returnvalue = returnvalue.replace(", RØDT", "");
      }

      return returnvalue;
    },
    
    getYrCardIcon(hazardTypeId, level) {
      let type = hazardTypeId.toLowerCase();
      let lvl = level;

      switch (hazardTypeId.toLowerCase()) {
        case "flood":
          type = "flood";
          break;
        case "landslide":
          type = "landslide";
          break;
        case "avalanches":
          type = "avalanches";
          if (level === 5) lvl = 4;
          break;
        case "rain":
        case "rainflood":
          type = "rain";
          break;
        case "ice":
          type = "ice";
          break;
        case "drivingconditions":
          type = "drivingconditions";
          break;
        case "icing":
          type = "icing";
          break;
        case "blowingsnow":
          type = "snow";
          break;
        case "snow":
          type = "snow";
          break;
        case "wind":
          type = "wind";
          break;
        case "forestfire":
          type = "forestfire";
          break;
        case "stormsurge":
          type = "stormsurge";
          break;
        case "polarlow":
          type = "polarlow";
          break;
        case "freezingrain":
          type = "drivingconditions";
          break;
        case "thunder":
          type = "thunder";
          break;
        default:
          type = "generic";
          break;
      }
      let col = "yellow";
      if (lvl == 3) col = "orange";
      if (lvl == 4) col = "red";
      let imgName = `icon-warning-${type}-${col}`;
      return imgName;
    },
    getLevelText(hazardTypeId, level) {
      let text = "GULT";
      if (hazardTypeId == "avalanches" && level == 5)
        text = "GULT, ORANSJE, RØD, SVART";
      if (level == 4) text = "GULT, ORANSJE, RØD";
      if (level == 3) text = "GULT, ORANSJE";
      return text;
    },
    getAlertLevelText(hazardTypeId, level) {
      if (level == 5) return "SVART";
      if (level == 4) return "RØD";
      if (level == 3) return "ORANSJE";
      if (level == 2) return "GULT";
      if (level == 1) return "GRØNT";
    },
    getCardIcon() {
      var nameToCheck = this.getYrCardIcon(
        this.subscriptionType.hazardTypeId.toLowerCase(),
        this.subscription.level
      );
      const img = this.$store.getters.images.filter(
        (item) => typeof item === "string" && item.indexOf(nameToCheck) > -1
      );

      if (img.length > 0) {
        return img;
      }

      nameToCheck = `/img/icon-warning-generic-${this.subscription.level}`;
      return this.$store.getters.images.filter(
        (item) => typeof item === "string" && item.indexOf(nameToCheck) > -1
      );
    },
    subscriptionSaved() {
      this.$emit("subscriptionsChanged");
    },
    deleteSubscription() {
      axios.delete(`/api/api/Subscription/Delete/${this.subscription.id}`).then(
        () => {
          this.$emit("subscriptionsChanged");
        },
        () => {
          this.error = "Klarte ikke å fjerne varselet!";
        }
      );
    },

    pauseSubscription() {
      axios.post(`/api/api/Subscription/Pause/${this.subscription.id}`).then(
        () => {
          this.$emit("subscriptionsChanged");
        },
        () => {
          this.error = "Klarte ikke å pause varselet!";
        }
      );
    },
    resumeSubscription() {
      axios.post(`/api/api/Subscription/Resume/${this.subscription.id}`).then(
        () => {
          this.$emit("subscriptionsChanged");
        },
        () => {
          this.error = "Klarte ikke å aktivere varselet!";
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.oi-pencil {
  font-size: 80%;
}

.card {
  transition: background-color 1s;
}

.card-buttons {
  transition: background-color 1s;
}

.badge-secondary {
  background-color: #444;
  font-weight: normal;
  padding-bottom: 4px;
  padding-left: 12px;
  padding-right: 12px;
  float: right;
  border-radius: 2px;
}
</style>
